import { LanguageType, Location } from '@nx-smartmonkey/shared/domain';
import { getLocationFromCoordinates, postGeocode } from '../services/requests';
import { toCoords } from './Common';

export const parseAddresses = async ({
  addresses,
  projectId,
  language,
}: {
  addresses: string[];
  projectId?: string;
  language: LanguageType;
}) => {
  // const cleanAddresses = addresses.map(address => cleanString(address));

  const addressesMap: { [key: number]: string } = {};
  const coordinatesParsed: { [coordinate: string]: [number, number] } = {};
  const coordinatesResult: {
    [coordinates: string]: Location | null;
  } = {};
  const directionsResult: {
    [directions: string]: Location | null;
  } = {};

  addresses.forEach((address, idx) => {
    addressesMap[idx] = address;

    try {
      // Check if address are coordinates
      const coordinates = toCoords(address);
      if (coordinates) {
        coordinatesParsed[address] = coordinates;
        coordinatesResult[address] = null;
      } else {
        directionsResult[address] = null;
      }
    } catch (_e) {
      // Do nothing
    }
  });

  const directionsResponse =
    Object.keys(directionsResult).length > 0
      ? await postGeocode({ addresses: Object.keys(directionsResult), projectId })
      : [];
  const coordinatesResponse =
    Object.values(coordinatesParsed).length > 0
      ? await getLocationFromCoordinates({
          coordinates: Object.values(coordinatesParsed).map((val) => ({ lat: val[0], lng: val[1] })),
          lang: language,
        })
      : [];

  Object.keys(directionsResult).forEach((id: string, idx: number) => {
    directionsResult[id] = directionsResponse[idx];
  });
  Object.keys(coordinatesResult).forEach((id, idx) => {
    coordinatesResponse[idx].original_input = Object.keys(coordinatesParsed)[idx];
    coordinatesResult[id] = coordinatesResponse[idx];
  });

  const response = [];
  for (const address of addresses) {
    response.push(directionsResult[address] || coordinatesResult[address] || null);
  }
  return response;
};
